//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import React from 'react';
import classNames from 'classnames';
import { RCChip } from '../RCChip/RCChip';

interface RCListingGridProps {
  children: React.ReactNode;
  loading?: boolean;
  sidebar?: React.ReactNode;
  sidebarOpen?: boolean;
  singleRow?: boolean;
}

export function RCListingGrid({
  loading = false,
  singleRow = false,
  sidebarOpen = false,
  sidebar,
  children,
}: RCListingGridProps) {
  return (
    <div className={classNames(
      'rc-listing-grid',
      { 'rc-listing-grid--loading': loading },
      { 'rc-listing-grid--single-row': singleRow },
      { 'rc-listing-grid--sidebar-open': sidebarOpen },
    )}>
      {sidebar}
      <ol className="rc-listing-grid__content">
        {children}
      </ol>
    </div>
  );
}

interface GridItemProps {
  colSpan?: 'one' | 'all',
  children: React.ReactNode;
}

function ListingGridItem({
  colSpan = 'one',
  children,
}: GridItemProps) {
  return (
    <li className={classNames(
      'rc-listing-grid__item',
      { 'rc-listing-grid__item--span-all': colSpan === 'all' },
    )}>
      {children}
    </li>
  );
}

interface ListingGridToggleControlProps {
  onChange: () => void;
  children: React.ReactNode;
}

function ListingGridToggleControl({
  onChange,
  children,
}: ListingGridToggleControlProps) {
  return (
    <div className="rc-listing-grid__toggle-control">
      <RCChip
        onChange={onChange}
      >
        {children}
      </RCChip>
    </div>
  );
}

interface ListingGridSidebarContentProps {
  children: React.ReactNode;
}

function ListingGridSidebarContent({
  children,
}: ListingGridSidebarContentProps) {
  return (
    <div className="rc-listing-grid__sidebar__content">
      {children}
    </div>
  );
}

interface ListingGridSidebarProps {
  children: React.ReactNode;
}

function ListingGridSidebar({
  children,
}: ListingGridSidebarProps) {
  return (
    <div className="rc-listing-grid__sidebar">
      {children}
    </div>
  );
}

interface ListingGridSidebarHeaderProps {
  children: React.ReactNode;
}

function ListingGridSidebarHeader({
  children,
}: ListingGridSidebarHeaderProps) {
  return (
    <div className="rc-listing-grid__sidebar__header">
      {children}
    </div>
  );
}

interface ListingGridSidebarFooterProps {
  children: React.ReactNode;
}

function ListingGridSidebarFooter({
  children,
}: ListingGridSidebarFooterProps) {
  return (
    <div className="rc-listing-grid__sidebar__footer">
      {children}
    </div>
  );
}

RCListingGrid.Item = ListingGridItem;
RCListingGrid.ToggleControl = ListingGridToggleControl;
RCListingGrid.Sidebar = ListingGridSidebar;
RCListingGrid.SidebarContent = ListingGridSidebarContent;
RCListingGrid.SidebarHeader = ListingGridSidebarHeader;
RCListingGrid.SidebarFooter = ListingGridSidebarFooter;
